import {
  enableProdMode,
  importProvidersFrom,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';

registerLocaleData(localeEs, 'es-ES');

import { VisorgisModule } from './app/pages/visorgis/visorgis.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { HighchartsChartModule } from 'highcharts-angular';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MomentModule } from 'ngx-moment';
import { AppRoutingModule } from './app/app-routing.module';
import { IonicStorageModule } from '@ionic/storage-angular';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { UrlService } from './app/services/url.service';
import { InterceptorService } from './app/interceptors/interceptor.service';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  provideIonicAngular,
  IonicRouteStrategy,
} from '@ionic/angular/standalone';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import 'chartjs-adapter-moment';
import { IonicModule } from '@ionic/angular';
import { OAuthStorage, provideOAuthClient } from 'angular-oauth2-oidc';
import { oauthStorageFactory } from './app/services/app-session-storage.service';
import { configureMomentLocale } from './app/shared/utils/date-time.utils';

configureMomentLocale();

// comentario
if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(
      BrowserModule,
      IonicModule.forRoot(),
      IonicStorageModule.forRoot(),
      AppRoutingModule,
      MomentModule,
      MatTooltipModule,
      MatButtonModule,
      ReactiveFormsModule,
      HighchartsChartModule,
      // Module Snackbar
      MatSnackBarModule,
      VisorgisModule,
      RouterModule
    ),
    /* { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }, */
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true,
    },
    UrlService,
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideCharts(withDefaultRegisterables()),
    provideIonicAngular({ mode: 'ios' }),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: LOCALE_ID, useValue: 'es-ES' },
    provideOAuthClient(),
    // Debe ir DESPUÉS de provideOAuthClient(): ese API registra sessionStorage
    // y el último provider del token gana.
    { provide: OAuthStorage, useFactory: oauthStorageFactory },
  ],
}).catch(err => console.log(err));
